import useTranslation from 'next-translate/useTranslation';
import * as LocalStorage from '../utils/localStorage';
import useMessageHandler from './useMessageHandler';

const LOCAL_STORAGE_KEY = 'referrerCode';

interface UseReferrerCode {
  rememberReferrerCode: (code: string) => void;
  getReferrerCode: () => string | null;
  setRefereeCouponAlert: () => void;
}

const useReferrerCode = (): UseReferrerCode => {
  const { t } = useTranslation('common');
  const { setSuccess } = useMessageHandler();

  const rememberReferrerCode = (code: string) => {
    LocalStorage.saveItem(LOCAL_STORAGE_KEY, code);
  };

  const unsetReferrerCode = () => {
    LocalStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  const getReferrerCode = () => {
    return LocalStorage.getItem(LOCAL_STORAGE_KEY);
  };

  const setRefereeCouponAlert = () => {
    const code = LocalStorage.getItem(LOCAL_STORAGE_KEY);
    if (!code) return;
    setSuccess(t('Promo.addSuccessAmountOff', { amount: t('Referral.referralDiscount') }));
    unsetReferrerCode();
  };

  return { rememberReferrerCode, getReferrerCode, setRefereeCouponAlert };
};

export default useReferrerCode;
